import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { NeedTypeTag } from './NeedTypeTag';
import { AdditionalWorkTag } from './AdditionalWorkTag';

export const NeedTypeSectionTags: React.FC = () => (
  <Stack direction="row" gap="2" alignItems="center" wrap="wrap" minWidth={0}>
    <Container>
      <NeedTypeTag />
    </Container>
    <Container>
      <AdditionalWorkTag />
    </Container>
  </Stack>
);
